module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THE BITTEN")]), _vm._v(". Copyright © 2005 by Leslie Esdaile Banks. All rights reserved. Printed in the United States of America. No part of this book may be used or reproduced in any manner whatsoever without written permission except in the case of brief quotations embodied in critical articles or reviews. For information, address St. Martin’s Press, 175 Fifth Avenue, New York, N.Y. 10010.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "href": "http://www.stmartins.com",
      "target": "_blank"
    }
  }, [_vm._v("www.stmartins.com")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Banks, L. A.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The bitten / L. A. Banks.—1st ed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("   p. cm.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("ISBN 0-312-32408-1")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("EAN 978-0312-32408-7")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("1. Richards, Damali (Fictitious character)—Fiction. 2. Women in the performing arts—Fiction. 3. African American women—Fiction. 4. Women martial artists—Fiction. 5. Vampires—Fiction. I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("PS3602.A64B58 2005")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("813’.6—dc22                                                                                                                        2004051163")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("First Edition: February 2005")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("10 9 8 7 6 5 4 3 2 1")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49af5c96","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 66
// module chunks = 0